import React from 'react';
import PropTypes from 'prop-types';
import {
  ResultCellWrapper,
  Title,
  Content,
  ResultContainerWrapper,
  ContainerContent,
  IconWrapper
} from './result-cell.styled';
import SvgIcon from '../svg-icon/svg-icon';

const ResultCell = ({ title, value, container, children, icon }) => {
  if (container) {
    return (
      <ResultContainerWrapper>
        <Title>
          <IconWrapper>
            <SvgIcon icon={icon} />
          </IconWrapper>
          {title}
        </Title>
        <ContainerContent>{children}</ContainerContent>
      </ResultContainerWrapper>
    );
  }

  return (
    <ResultCellWrapper data-testid="result-cell">
      <Title>
        <IconWrapper>
          <SvgIcon icon={icon} />
        </IconWrapper>
        {title}
      </Title>
      <Content>{value}</Content>
    </ResultCellWrapper>
  );
};

ResultCell.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  container: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.string
};

ResultCell.defaultProps = {
  container: false,
  icon: ''
};

export default ResultCell;



// WEBPACK FOOTER //
// ./components/result-cell/results-cell.js